import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { LagDeviceModel } from '../../../../@store/cascades/lag-device.model';
import { PillType } from '../../../../shared/components/pill/pill.model';

@Component({
  selector: 'app-lag-device-tile',
  templateUrl: './lag-device-tile.component.html',
  styleUrls: ['./lag-device-tile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LagDeviceTileComponent {
  readonly pillType = PillType;
  @Input() lagDevice: LagDeviceModel;
  @Output() showDetails: EventEmitter<string> = new EventEmitter<string>();

  constructor() {}

  openLagDeviceDialog(id: string): void {
    this.showDetails.emit(id);
  }

  getStandardImageUri(): string {
    return '/assets/img/devices/device_big.png';
  }
}
